export default function initDropdownsText() {
    const dropdownsListContainers = document.querySelectorAll('.js-dropdowns-list') as NodeListOf<HTMLElement>;
    dropdownsListContainers.forEach(container => {
        new DropdownsText(container);
    });
}

class DropdownsText {
    dropdownsListContainer: HTMLElement;

    constructor(container: HTMLElement) {
        this.dropdownsListContainer = container;
        this.init();
    }

    init() {
        if (this.dropdownsListContainer) {
            if (this.dropdownsListContainer.classList.contains('first-open')) {
                const firstDropdown = this.dropdownsListContainer.querySelector('.dropdown') as HTMLDetailsElement;
                if (firstDropdown) {
                    firstDropdown.open = true;
                }
            }

            if (this.dropdownsListContainer.classList.contains('only-one-open')) {
                const dropdowns = this.dropdownsListContainer.querySelectorAll('.dropdown') as NodeListOf<HTMLDetailsElement>;

                dropdowns.forEach((dropdown) => {
                    dropdown.addEventListener('toggle', () => {
                        if (dropdown.open) {
                            dropdowns.forEach((item) => {
                                if (item !== dropdown) {
                                    item.open = false;
                                }
                            });
                        }
                    });
                });
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initDropdownsText();
});
